// native
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// service
import { ApiService } from './api.service';
import { GlobalsService } from './globals.service';
import { UtilityService } from './utility.service';

// models
import { IItemTag, ITagDataResponse } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class TagsService {
  constructor(
    private apiService: ApiService,
    private globalsService: GlobalsService,
    private utilityService: UtilityService
  ) {
  }

  getTags(collectionId: string): Observable<IItemTag[]> {
    const endpointUrl = `${this.globalsService.appConfig.environment.baseUrls.sync}/collections/${collectionId}/items/tags`;
    return this.apiService.get(endpointUrl).pipe(
      map((body: ITagDataResponse) => {
        return (body.tags || []).map((tag: string) => {
          return { id: tag, name: this.utilityService.strtrunc(tag, 32, false) };
        });
      }));
  }
}